import  * as React from "react";
import { observer } from "mobx-react";
import {ISingleShotControlParams} from "./ISingleShotControlParams";
import { SponsorDetails } from "./../SponsorDetails/SponsorDetails";
import { ISponsorDetailsProps } from "./../SponsorDetails/ISponsorDetailsProps";
import { IParameterSettingsPanelParams } from "./../SingleShotControl/ParameterSettingsPanel/IParameterSettingsPanelParams";
import { SingleTile } from "../TileControl/SingleTile";
import { ISingleTileProps } from "../TileControl/ISingleTileProps";
import { ParameterHelper } from "MeasurementsCalculations";
import { ISingleMeasurementParameter, } from "Data";
import { ParameterSettingsPanel } from "./ParameterSettingsPanel/ParameterSettingsPanel";

export interface ISingleShotControlState {
    selectedTileAdditionalInformation: string;
}

@observer
export class SingleShotControl extends React.Component<ISingleShotControlParams, ISingleShotControlState>{
    constructor(props: ISingleShotControlParams) {
        super(props, undefined);
        this.state = { selectedTileAdditionalInformation: "" };
        this.loadData(props);
    }
       
    //TODO those two functions caused the recurring problem.  But at the same time, fixes the problem with the units next not updating on the tiles. 
    componentWillReceiveProps(nextProps: ISingleShotControlParams) {
        this.loadData(nextProps);
    }

    loadData(props: ISingleShotControlParams) {
        if (props.measurementParameters.length === 0) {
            props.loadTiles();
        } else {
            props.updateUnitOnTiles();
        }
    }
    setAdditionalInfoUrl(url: string) {
        this.setState({ selectedTileAdditionalInformation: url });
    }

    private getSponsorDetailsParams() {
        const result: ISponsorDetailsProps = {
            sponsors: this.props.sponsors,
            facilities: this.props.facilities,
            isWeb: this.props.isWeb,
            isTps: this.props.isTps
        };
        return result;
    }

    private getParameterSettingsPanelParams() {
        const result: IParameterSettingsPanelParams = {
            color: this.props.selectedGroupOfStrokes ? this.props.selectedGroupOfStrokes.color ?? '' : '',
            playerName: this.props.selectedGroupOfStrokes ? this.props.selectedGroupOfStrokes.player?.name ?? '': '',
            unitPresentation: this.props.unitPresentation,
            changeUnit: this.props.changeUnit,
            disableTile: this.props.disableTile,
            measurementParameters: this.props.measurementParameters,
            showChangeDataAndUnitsButtons: this.props.showChangeDataAndUnitsButtons,
            reportStore: this.props.reportStore
        };
        return result;
    }

    renderAdditionalInfoModal() {
        return <div className="modal fade" id="showAdditionalInfoOnTile" tabIndex={-1} role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <img src="Images/MultiGroupReport/Close_icon.svg" alt="" className="close-tiles-list-btn" data-dismiss="modal" aria-label="Close" />
                        <iframe src={this.state.selectedTileAdditionalInformation} frameBorder="0" title="Additional information"></iframe>
                    </div>
                </div>
            </div>
        </div>;
    }
    private getSingleTileParams(tileKind: string, parameter: ISingleMeasurementParameter) {
        let valueOfParameter = "";
        switch (tileKind) {
            case 'EmptyTile':
                {
                    valueOfParameter = '';
                    break;
                }
            case 'TileWithoutValues': {
                valueOfParameter = '-';
                break;
            }
            case 'SelectedStrokeTile':
                {
                    if (this.props.selectedStroke)
                        valueOfParameter = ParameterHelper.getParameterValue(this.props.selectedStroke, parameter.propertyName, this.props.unitPresentation);
                    break;
                }
            default: {
                valueOfParameter = '';
                break;
            }
        }

        const result: ISingleTileProps = {
            title: tileKind === 'EmptyTile' ? '' : parameter.title,
            unit: tileKind === 'EmptyTile' ? '' : parameter.displayUnit,
            value: valueOfParameter,
            isWeb: this.props.isWeb,
            isIos: this.props.isIos,
            isTps: this.props.isTps,
            infoPage: parameter.myTrackManPage,
            color: this.props.selectedGroupOfStrokes && this.props.selectedGroupOfStrokes.color ? this.props.selectedGroupOfStrokes.color : '#c1c1c1',
            isEmpty: tileKind === 'EmptyTile' ? true : false,
            enableInfoModal: true,
            setAdditionalInfoUrl: this.setAdditionalInfoUrl.bind(this),
        };
        return result;
    }

    render() {
        return <div className={`SingleShotControl ${this.props.className}`}>
                   <div className="tiles-and-sponsor-info">
                       <ParameterSettingsPanel {...this.getParameterSettingsPanelParams() }></ParameterSettingsPanel>
                       <div style={{ marginLeft: 0 }}>
                           <div className="container-for-stroke-row">
                               {
                                   this.props.measurementParameters.map((parameter, i) => {
                                       if (parameter.isVisible) {
                                           return <SingleTile className="single-tile" key={'a'+parameter.propertyName} data-toggle="modal" {...this
                                               .getSingleTileParams('SelectedStrokeTile', parameter) }></SingleTile>
                                       }
                                       return null;
                                   })}
                               {this.props.measurementParameters.map((parameter, i) => {
                                       if (i < (10 -
                                           this.props.measurementParameters.filter((x) => { return x.isVisible; })
                                           .length)) {
                                           return <SingleTile className="single-tile" key={'b'+parameter.propertyName} data-toggle="modal" {...this
                                               .getSingleTileParams('EmptyTile', parameter) }></SingleTile>
                                       }
                                       return null;
                                   })
                               }
                           </div>
                       </div>
                       {this.props.isWeb &&
                           this.props.showCommercial &&
                           this.props.className !== "first" &&
                           <div className="hidden-print">
                               <SponsorDetails {...this.getSponsorDetailsParams() }></SponsorDetails>
                           </div>
                       }
                   </div>
                   {this.renderAdditionalInfoModal()}
               </div>;
    }
}
